function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M1.3 15.6c-.2 0-.3 0-.5-.1-.6-.3-.9-1-.7-1.7C.2 13.7 6.1.3 22.7.3c.7 0 1.3.6 1.3 1.3 0 .7-.6 1.3-1.3 1.3-14.9 0-20.2 11.8-20.3 12-.2.5-.6.7-1.1.7z",
  fill: "#231F20",
  fillRule: "nonzero"
});

var SvgComponent = function SvgComponent(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 16,
    viewBox: "0 0 24 16"
  }, props), _ref);
};

export default SvgComponent;